import React from 'react';

export const LockSpot = (): React.ReactElement => (
  <svg
    fill="none"
    height="56"
    viewBox="0 0 56 56"
    width="56"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="27.6784" cy="28.0563" fill="#F7F5F0" r="27.6784" />
    <path
      clipRule="evenodd"
      d="M13 26.2337C13 24.9901 14.0081 23.9819 15.2518 23.9819H39.7482C40.9919 23.9819 42 24.9901 42 26.2337V41.0635C42 42.3071 40.9919 43.3153 39.7482 43.3153H15.2518C14.0081 43.3153 13 42.3071 13 41.0635V26.2337Z"
      fill="#38AF88"
      fillRule="evenodd"
    />
    <path
      d="M13 26.2337C13 24.9901 14.0081 23.9819 15.2518 23.9819L36.2425 23.9819L19.3867 43.3153H15.2518C14.0081 43.3153 13 42.3071 13 41.0635V26.2337Z"
      fill="white"
      fillOpacity="0.15"
    />
    <path
      clipRule="evenodd"
      d="M23.3916 32.561C23.3916 30.292 25.231 28.4526 27.4999 28.4526C29.7689 28.4526 31.6083 30.292 31.6083 32.561C31.6083 34.1893 30.6522 35.6359 29.2137 36.2959L29.1916 36.3057V37.2735C29.1916 38.1951 28.4545 38.9446 27.5377 38.9647L27.4999 38.9651C26.5657 38.9651 25.8083 38.2078 25.8083 37.2735V36.3058L25.7863 36.296C24.3637 35.6433 23.4129 34.2214 23.392 32.6152L23.3916 32.561ZM30.6416 32.5609C30.6416 30.8258 29.235 29.4192 27.4999 29.4192C25.7648 29.4192 24.3582 30.8258 24.3582 32.5609C24.3582 33.9031 25.2077 35.0839 26.4526 35.5239L26.7749 35.6378L26.7749 37.2734C26.7749 37.6738 27.0995 37.9984 27.4999 37.9984C27.9003 37.9984 28.2249 37.6738 28.2249 37.2734L28.225 35.6378L28.5473 35.5239C29.7921 35.0838 30.6416 33.9031 30.6416 32.5609Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M25.8081 32.5608C25.8081 31.6265 26.5655 30.8691 27.4998 30.8691C28.4341 30.8691 29.1914 31.6265 29.1914 32.5608C29.1914 33.4951 28.4341 34.2525 27.4998 34.2525C26.5655 34.2525 25.8081 33.4951 25.8081 32.5608ZM28.2247 32.5608C28.2247 32.1604 27.9001 31.8358 27.4997 31.8358C27.0993 31.8358 26.7747 32.1604 26.7747 32.5608C26.7747 32.9612 27.0993 33.2858 27.4997 33.2858C27.9001 33.2858 28.2247 32.9612 28.2247 32.5608Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      d="M27.4998 10.0859C33.0965 10.0859 37.6782 14.3962 37.7693 19.7902L37.7707 19.954V23.9818H34.1457V19.954C34.1457 16.5264 31.1895 13.7109 27.4998 13.7109C23.8471 13.7109 20.9132 16.4703 20.8549 19.8513L20.854 19.954V23.9818H17.229V19.954C17.229 14.4837 21.8467 10.0859 27.4998 10.0859Z"
      fill="#38AF88"
    />
  </svg>
);
